export const getUser = () => {
  const userid = sessionStorage.getItem("sma_uid");
  if (userid) return JSON.parse(userid);
  else return null;
};

export const getUserid = () => {
  return sessionStorage.getItem("sma_auth") || null;
};

export const setUserid = (token) => {
  sessionStorage.setItem("sma_auth", token);
};
export const setUser = (token) => {
  sessionStorage.setItem("sma_user", token);
};

export const getToken = () => {
  return sessionStorage.getItem("sma_uid") || null;
};

export const getApplicationId = () => {
  return localStorage.getItem("sma_app") || null;
};

export const getLocalToken = () => {
  return localStorage.getItem("sml_tk") || null;
};

export const setUserSession = (token) => {
  sessionStorage.setItem("sma_uid", token);
  localStorage.setItem("sml_tk", token);
};
export const setUserApp = (id) => {
  localStorage.setItem("sma_app", id);
};

export const removeUserSession = () => {
  sessionStorage.removeItem("sma_uid");
  localStorage.removeItem("sml_tk");
  localStorage.removeItem("sma_app");
  sessionStorage.removeItem("sma_auth");
};

export const colorClass = (item) => {
  if (item === "OTT") {
    return "ribbon bg-primary";
  } else if (item === "Education") {
    return "ribbon bg-warning";
  } else if (item === "Health Care") {
    return "ribbon bg-success";
  } else {
    return "ribbon bg-danger";
  }
};

export const getPreviewUrl = () => {
  // return "http://localhost:3001/"+getApplicationId();
  return process.env.REACT_APP_PREV_DEV_URL + getApplicationId();
};

export function isoFormatDMY(d) {
  function pad(n) {
    return (n < 10 ? "0" : "") + n;
  }
  return (
    pad(d.getUTCDate()) +
    "/" +
    pad(d.getUTCMonth() + 1) +
    "/" +
    d.getUTCFullYear()
  );
}

export function parseISOString(s) {
  let date = new Date(s);
  return (
    date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
  );
}
